import React from "react";
import { Link } from "react-router-dom";
import "./Post.css";

const Post = (props) => {
  const { id, title, subtitle, date, image_url, content, author } = props.post;

  return (
    <>
      <hr />
      <div className="post">
        {image_url && (
          <div className="post-image">
            <img src={image_url} alt={title} />
          </div>
        )}
        <div className="post-details">
          <Link to={"/blog/post/" + id + "/"}><h2>{title}</h2></Link>
          <h3>{subtitle}</h3>
          <p>{`Fecha de publicación: ${date}`}</p>
          <div dangerouslySetInnerHTML={{ __html: content.length > 420 ? content.substring(0, 420) + "..." : content }}></div>
          <p>{author}</p>
        </div>
      </div>
      <hr />
    </>
  );
};

export default Post;
